  var title = document.getElementsByClassName("announcement-bar__message")[0];
    var colors = new Array('rgb(000, 000, 000)',
                           'rgb(255, 255, 255)'
                           );
    var count = 1;
    var interval = window.setInterval(changeColor, 1250);
    function changeColor() {
        title.style.color = colors[count++];
    if (count == 3)
            count = 0;
    }